module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "الفصل-الثاني-عماد-الدين-زنكي"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الفصل الثاني")]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عماد الدين زنكي")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("آق - سونقور، كان مِن الضبَّاط المفضَّلين للحاكم مالك شاه، أحد أشهَر الحكام السلاجقة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كان محبوبًا ومخلصًا في عمله، فاعتمد عليه في كثير من الأمور، وهو ما جعله ينال ثقته، فزادت منزلته")]), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn1",
      "id": "fnref1"
    }
  }, [_vm._v("1")]), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("، وأدَّى ذلك لزيادة أعدائه، فدفَع نتيجة إخلاصه باغتياله عام ١٠٩٤ م، وقد ترَك ولدًا عمره عشر سنوات، هو عماد الدين زنكي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لَم ينسَ الحكَّام فضل أبيه، فتولَّوا رعاية زنكي، وأشرفوا على تعليمه وتدريبه، وكان حاكم بلاد ما بين النهرين (الجزيرة في العراق والشام) كوردوجا العظيم يصطحب زنكي للمعارك، ويوصي جنوده بحمايته، وكان عماد الدين يظلُّ معهم حتَّى ينتصروا. وظَلَّ يحظَى بهذه الرعاية إلى أن اشتدَّ عوده، وطالت قامته، وأصبحَت له عيون ثاقبة وشخصية عسكرية ملتزِمة")]), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn2",
      "id": "fnref2"
    }
  }, [_vm._v("2")]), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("توالى على الموصل خَمسة حكَّام متتالون كلٌّ بَعد الآخَر يعتني بزنكي ويزيده حبًّا وعطاءً، حتَّى بلغ الثامنة والثلاثين، فتعلَّمَ بخلاف العسكرية أمور القصور السياسية مِن دسائس وكيفية نشر الجواسيس.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في إحدى الغزوات على طبرية كان منضمًّا للجنود، ونجحوا في طرد كتيبة مِن الفرسان الصليبيين، ثمَّ تابعهم زنكي وهم يفرُّون مِن باب المدينة شاهرًا سيفه. ونظر خلفه لِلَحظة، فوجد أنَّ جنوده توقَّفوا عن الملاحقة، وأنَّه أصبح وحيدًا يلاحق العدو، انتظَر قليلًا كي يلحق به جنوده، ولكنَّهم لَم يفعلوا وتركوه وحيدًا مع العدو المنسحِب، فاضطُرَّ للرجوع، وقد انتشرَت هذه القصة بسرعة، واكتسَب مِن يومها لقب \"الشَّامي\".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أظهر عماد الدين زنكي تفوُّقًا عسكريًّا ظاهرًا فيما يلي مِن أحداث، وتمَّ تعيينه واليًا على واسط والبصرة في عام ١١٢٤ م")]), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn3",
      "id": "fnref3"
    }
  }, [_vm._v("3")]), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أراد عرب جنوب العراق (ساكِنو المستنقعات التي يصبُّ فيها كلٌّ مِن دجلة")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("والفرات) استرجاع سيطرتهم على تلك الأراضي الخصبة شمالًا، ولكن فشلَت كلُّ محاولاتهم بسبب عماد الدين زنكي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في الأول مِن مارس عام ١١٢٣م قامت معركة بين العرب والخليفة، كان يقود العرب دبيس بن صدقة مِن قبيلة أسد، فزحف بجيشه يحتلُّ مدنًا في اتِّجاه بغداد، لَم يكن الخليفة العباسي \"المسترشِد\" متقاعسًا، فقد جمع حُرَّاسه الأتراك، وزحف يقود جيشه وهو يرتدي عباءة الرسول صلى الله عليه وسلم، وعِمامة سوداء، وعبَر الجيش النهر، والتَقَى بوالي الموصل البرصقي، وعماد الدين زنكي والي البصرة، وقاضي القضاة، ورئيس العلماء، ومجموعة مِن النبلاء، وبمجرَّد نزوله مِن على الفَرس خَرَّ الجميع ساجدين يقبِّلون الأرض، ثمَّ استقبلَهم الخليفة المسترشد في خيمته كلٌّ على حِدة، يتعهَّدون له بالطاعة والولاء.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("التقى الجيشان عند التقاء النهرين، كان الجيش العربي يتكوَّن مِن عشرة آلاف فارس واثني عشر ألفًا مِن المشاة، أمَّا الخليفة ومَن معه فكان جيشهم يتكوَّن مِن ثمانية آلاف فارس وأقَل مِن خمسة آلاف مِن المشاة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تمركز الخليفة في الخلف مِن وسط الجيش ليرى كل شيء، وكان أمامه شيخان كلٌّ منهما يُمسك بمصحف مفتوح، يرتِّلان القرآن تباعًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كان عماد الدين زنكي يقود الجناح الأيسر، بدأَتِ المعركة بهجمتين بارعتين للجيش العربي، وكادت جنود الخليفة أن تفرَّ هربًا، إلَّا إنَّ زنكي هجم عليهم مِن الجانب الأيسر، وبمساعدة البرصقي نجحا في دفع جيش العرب إلى النهر.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("انتهَتِ المعركة بانتصار الخليفة، وتمَّ قتل الأسرى جميعهم، وهرب دبيس")]), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn4",
      "id": "fnref4"
    }
  }, [_vm._v("4")]), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("، وكانت مكافأة زنكي زواجه مِن أرملة السلطان كوندوغلي، وتنصيبه واليًا على الموصل وبلاد ما بين النهرين (الجزيرة).")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كان لزنكي أسلوب خاص في الحكم، فقد كَوَّن شبكة مِن المفتِّشين، ونشرَهم في أنحاء البلاد تراسله بالأخبار، وعَيَّن شبكة أخرى مِن الجواسيس تراقبهم وتؤكِّد له صحة كلام المفتِّشين.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كانت له عيون في كل مكان، حتَّى قصور الأمراء والسلطان.. كان هناك عدد مِن المراسلين يأتون بأخبار مكتوبة مِن كلِّ جهة كلَّ يوم، حتَّى تفاصيل ما يفعله السلطان طوال اليوم")]), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn5",
      "id": "fnref5"
    }
  }, [_vm._v("5")]), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لَم يكن عماد الدين زنكي مهمِلًا أو ليِّنا في التعامل مع موظَّفيه")]), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn6",
      "id": "fnref6"
    }
  }, [_vm._v("6")]), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("، ويُحكَى أنَّه فاجأ المراكبي الخاص به نائمًا بدلًا مِن أن يكون متيقِّظًا ينتظر سيِّده، فوجئ المراكبي بزنكي واقفًا أمامه، فخَرَّ ميِّتًا في الحال.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كان خَدَمه وعبيده يشتكون مِن معاملته الخشنة لهم، ولهم الحق في ذلك، فمع شراسة طباعه كان لا يَقبل أن يعامل أحد قوَّاده النَّاس بتلك المعاملة.. كان يقول: \"لا يجب أن يكون هناك أكثر مِن طاغٍ واحد في نفس الزمن وفي نفس البلد\".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قيل إنَّه في إحدى الغزوات علمَ أنَّ أحدًا مِن أكفأ قادته قد طَرد عائلة يهودية مِن بَيتهم إلى الخلاء البارد كي يستخدم البيت كمسكن للعسكر، فذهب لهذا القائد، ووقف أمامه، ونظر إليه نظرة واحدة مِن دون كلام، خرج بعدها القائد والعسكر، ونصَبوا خيمة في العراء، وأمضَوا ليلتهم تحت المطر، ورجعَتِ العائلة لبيتها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كان عماد الدين زنكي يكافئ العمل الحسن والطاعة، أمَّا إهانة وظلم الناس فكانت غير مسموح بها مطلقًا، وخاصّةً النِّساء اللائي كان لهنَّ وضع ومعاملة راقية؛ فلَم يحصلن على احترام وتقدير في عهد أي حاكم مثلما حصلنَ عليه في عهد زنكي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كانت زوجات المقاتلين في حمايته الخاصة، وقد بلغَه ذات مرَّة أنَّ أحد الولاة تعرَّضَ لامرأة، فعاقَبه بقَلع عينه وقَطع عضوه الذَّكري.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كتبَت مراجع غربية كيف ارتكب عماد الدين زنكي جرائم، وصوَّرَته بصورة بشعة، حتَّى إنَّ الصليبيِّين كانوا يُطلِقون عليه \"زنكي الدموي\".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يقولون إنَّه كان يزيل فروة رأس الأعداء المهمِّين، ويشنق فقط الأقَلَّ أهميَّة، وعندما ينفي ضبَّاطه المقصِّرين كان يذكِّرهم بقوَّته وجبروته بخَصي أولادهم، وإذا هرب أحد جنوده كان يأمر أن يُشَقَّ زميلان له مِن الوسط.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كان يشرب الخمر، وكانت تصرُّفاته أحيانًا لا تُذكَر مِن قسوتها")]), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn7",
      "id": "fnref7"
    }
  }, [_vm._v("7")]), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("، ومع ذلك كانت له حكمة عظيمة، حيث كان يفرِّق مخزون الأموال بين القلاع وفي أنحاء البلاد، ولا يجعلها كلها في مكان واحد، ويقول: \"إذا كانت كل الأموال في مكان وأنا بآخَر، وحدَثَ حادث، لن أنتفع بها، وضاعَت، أمَّا إذا كانت متفرِّقة رجعَت إلى بعضها\".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كان ردُّ فِعل تلك السياسة في الحكم انتشار السلام، والطمأنينة، والرخاء، وزيادة في إنتاج المحاصيل الزراعية، وفي البناء والتعمير.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كان عماد الدين زنكي شخصية فريدة، صارمًا وحازمًا، وقائدًا يعشق النظام والضبط والربط، ويعرف كيف يكتسب ثقة واحترام جنوده، مع ذلك كان يكره الرفاهية، فعندما يدخل مدينة كان يترك قصورها، ويقيم في خيمة خارج أسوارها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("زاد طموح عماد الدين زنكي في غرب الشام ودمشق، ولتحقيق هذا الطموح كان يجب عليه التصدي لعائقَين: الصليبيين، وأمراء مقاطعات مختلفة، كان أكثرهم نشاطًا وقوَّة حاكم ديار بكر، ويُدعَى داود الذي أصبح لا بدَّ مِن التعامل معه قبل أن يفكر زنكي في سوريا؛ لذا اتَّجَهَت أوَّل حملاته إلى جزيرة ابن عمر التي كانت تهدد الموصل.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عبَر عماد الدين زنكي بجيشه نهر دجلة، مجموعة عَومًا وأخرى بمراكب، عاونهم سكان المدينة حتَى دخلوها في الوقت المناسب؛ ففي اليوم التالي حدث فيضان وأصبح مِن المستحيل عبور النهر، ثمَّ زحف الجيش إلى نصيبين (على حدود تركيا وسوريا)، وحاز عليها بلعبة ماكرة، فقد أمسك بواحد مِن الحمام الزاجل للعدو، وقام عماد الدين زنكي بتغيير الرسالة المبعوثة، ونتج عن هذا استسلام فوري لمدينة نصيبين وهروب داود")]), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn8",
      "id": "fnref8"
    }
  }, [_vm._v("8")]), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تبقى خطر مدن شمال الفرات التي كانت ملك الصليبيين، وكانت محميَّة بأكثر جنودهم شراسة، وعلى رأسهم جوسيلين دي كورتني؛ لذا فضَّل زنكي التفاوض للهدنة، وحصل عليها بالفعل، وخلَت له الساحة للتعامل مع سوريا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وصلَته رسالة مِن حلب طالبة الحماية مِن خطر الصليبيين، فعبَر بجيشه نهر الفرات، ووصل حلب، حيث استُقبِل بالترحاب، وبعد سَنة في حلب زحف إلى قلعة الأتارب على مسيرة يوم غربًا، فقد كانت دائمًا مصدر إزعاج لحلب لموقعها وتفوُّق جنودها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قام عماد الدين زنكي بحصار القلعة، وقاوم دفاعاتها، بعثَتِ القلعة استغاثة لملك القدس بولدوين، فزحف بجيش كبير مِن الفرسان والمشاة الأمراء والأعلام والصلبان لملاقاة عماد الدين زنكي، فاقترَح مستشارو زنكي الانسحاب لحلب، لكنَّه أبَى وزحف لاستقبال جيش الصليبيين.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بدأَت معركة حامية، تقدَّم زنكي وجنوده وهو يصيح في أعدائه \"ذوقوا طعم جهنم\"")]), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn9",
      "id": "fnref9"
    }
  }, [_vm._v("9")]), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("انهزَم الصليبيون هزيمة منكرة، واستطاع القليل منهم الهروب لسرد القصة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عاد عماد الدين زنكي لقلعة الأتارب التي استسلمَت، ثمَّ عاد إلى الموصل ليداوي جراح جنوده، وقد أصبح له صيت عالٍ وشهرة مدوِّية للشجاعة والإقدام والبسالة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قضى زنكي أربع سنوات يرعَى أحوال البلاد؛ فقد بدأَتِ الحالة السياسية في الغليان بعد وفاة السلطان، ودخلَ العراق فترة تطاحُن بين السلاجقة والخليفة والسلاجقة فيما بينهم.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في عام ١١٣٢م طلب مسعود مِن زنكي التدخُّل العسكري في معارك بين مسعود وأخيه")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بهروز، هُزِم")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عماد الدين زنكي، وفر مجروحًا إلى تكريت حيث نجم الدين أيوب (والد صلاح الدين) عمدة تكريت، الذي تولَّى العناية به، ورتَّب له وجنوده مراكب تُبحِر بهم شمالًا للموصل، ولَم ينسَ زنكي هذا الفضل طوال عمره")]), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn10",
      "id": "fnref10"
    }
  }, [_vm._v("10")]), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ظنَّ الخليفة أنَّ الفرصة سانحة لاسترداد الموصل مِن زنكي، فزحف إليها بجيشه، وحاصر المدينة، ولكنَّ زنكي استطاع أن يحاصر جيش الخليفة، حيث أصبح الخليفة وأعوانه محاصَرين بين سور المدينة وجيش زنكي، فاستسلم الخليفة، وفضَّل الرحيل.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قام عماد الدين زنكي بعدَّة محاولات فاشلة للحصول على دمشق، ولَم يستطِع الاستفادة مِن الصراع السياسي وانهيار الحكم فيها، ومع هذا استطاع الحصول على حمص بالزواج مِن أمِّ أمير دمشق.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وبعد عام فتَح بعلبك، وولَّى الحكم فيها لنجم الدين أيوب والد صلاح الدين، وفي عام ١١٣٧ م أطاح بجيش الفرنج في موقعة مونتفيراند")]), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn11",
      "id": "fnref11"
    }
  }, [_vm._v("11")]), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("، وأخذ مدنًا وقلاعًا مِن محافظة اللاذقية، وبعدها بعام دافع ببسالة عن الشام ضد هجوم رهيب مِن الإمبراطور البيزنطي جون كومينوس، فقد خرج الإمبراطور من القسطنطينية بمائة ألف محارب، فنزل على أنطاكية، فصالحه صاحبها بالمال، ثمَّ انضمَّ له جيش مِن الصليبيين الروم المقيمين في الشرق، وتحالف معهم حاكم دمشق المسلم معِين الدين أنر.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أمام هذا التجمُّع فضَّل زنكي الرجوع للموصل ليعيد حساباته، ولتجهيز ما يلزم، وزحف الإمبراطور فقهرَ مدنًا متتالية، مثل بيزا، وكفر تاب، ثمَّ حاصر شيزر، ففي أبريل ١١٣٨ م وصلَت لعماد الدين زنكي استغاثة مِن شيزر، فاتَّجَه بجيشه غربًا، وكان يعلم أنَّ قوَّته لا تكافئ قوَّة العدو، فلجأ لأساليب أخرى، منها هجمات لجنوده يتبعها فِرار سريع لاستنزاف العدو، ونشر شائعات بقرب وصول إمدادات، ودفع رشاوى كثيرة، كلُّ هذا أدَّى إلى إحباط عزيمة الإمبراطور، إضافة إلى غفلة ولا مبالاة أمراء الروم، فبعد أربعة وعشرين يومًا مِن الحصار انسحَب \"كلب الروم\" تاركًا معدَّاته، ومنها ثمانية عشر منجنيقًا استحوَذ عليها زنكي، وانتهَت مغامرة الإمبراطور بالفشل")]), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn12",
      "id": "fnref12"
    }
  }, [_vm._v("12")]), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ازدادت قوَّة التحالف بين دمشق والصليبيين، حيث وافق أنر على دفع مبلغ عشرين ألف قطعة ذهب سنويًّا لملك القدس، والتنازل له عن بانياس لو استطاع أخْذها مِن زنكي وطرْده مِن الشام، لكن زنكي وفَّر عليهم التعب، ورجع بجنوده للموصل، تاركًا بعلبكَّ لنجم الدين أيوب والد صلاح الدين.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('br')])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "4in",
      "height": "3.8173in"
    },
    attrs: {
      "alt": "",
      "src": "media/file4.png"
    }
  })]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("المصدر:")]), _vm._v(" www.britannica.com")]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كانت مدينة الرُّها (إيدسا) مِن أوَّل المدن المهمَّة التي وقعَت تحت احتلال الحملة الصليبية الأولى، كانت أهمِّيتها للمسلمين هو موقعها في شمال الجزيرة (المنطقة بين نهرَي دجلة والفرات)، وللمسيحيِّين كونها أول مدينة تعتنق الديانة المسيحية تحت حكم الملك أجبار، كان بها قبرَا اثنَين مِن الحواريِّين.. توماس وثاديوس، وكان معظم أهلها مِن الأرمن.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في عام ١١٤٤م اتَّجَه زنكي في حملة شرقًا لنَهر دجلة، وانتهَز هذه الفرصة الكونت جوسلين الثاني حاكم الرُّها، فتركها واتَّجَه نحو الغرب، وأبلَغ جهاز المخابرات هذه المعلومة لزنكي الذي استدار بجيشه في اتجاه الرُّها، فحاصرها وضربها بالمجانيق، وتمَّ هدم جزءٍ مِن سُورها، ودخل الجيش واستولى عليها في ٢٣ ديسمبر ١١٤٤م، فقتل كل الرجال، وأخذوا النساء والأطفال سبايا فيما عدا المسيحيِّين الشرقيِّين الذين حصلوا على السلام في بيوتهم، وأطلق سراح ألف وخمسمائة مِن الأسرى المسلمين.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الكنائس الغربية دُمِّرَت وبُنِيَت مساجد بدلًا منها، لكن تمَّ استثناء الكنائس الشرقية أما النعوش الفضية للملك أبجار والحواري ثاديوس فقد تم الاستيلاء عليها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بدأ زنكي بترميم الأسوار التي دُمِّرَت وإصلاح كلِّ ما تلف في الحرب كي تكون المدينة مقبولة للعيش وقادرة على الدفاع عن نفسها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كانت الموقعة كارثة للصليبيين، ونصرًا عظيمًا للخليفة في بغداد الذي أنعَم على زنكي بكثير مِن الألقاب \"زين الإسلام\"، \"الأمير المنتصر\"، \"عون المؤمنين\"")]), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn13",
      "id": "fnref13"
    }
  }, [_vm._v("13")]), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تُعَدُّ هذه السَّنة بداية حلم تحرير القدس والشرق مِن الغزو الصليبي، بدأ الشعراء حملة دِعائِيَّة موسَّعة للحثِّ على التعاون مع زنكي لتحقيق هذا الحلم، خاصةً بعد حصوله على هذه الشرعية مِن الخليفة في بغداد.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وُصِفَت موقعة الرُّها بــ \"غزوة الغزوات\"، استسلمَتِ المدن المجاوِرة تباعًا، وتحرَّر نهر الفرات مِن بغي الكفَّار، \"ظهَر الحقُّ وزهق الباطل\"، وظلَّ هذا النصر مصدر حديث للعالم الشرقي والغربي معًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يقال إنَّ الملك روجر ملك صقلية كان يعاير شيخًا مسلمًا بعدما تمكَّنَت جيوشه مِن هزيمة الشرقيين في صقلية، فيقول له: \"أين كان نبيُّكم ليدافع عنكم\"؟ فردَّ الشيخ: \"كان يعاون في فتح الرُّها\".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ضجَّ الحاضرون بالضحك، ثمَّ توقَّفوا بعد ملاحظة استياء الملك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("استمرَّ عماد الدين زنكي في إدارة شؤون الأراضي المكتسبة. كان عمره ٦٢ عامًا، وكان مليئًا بالنَّشاط والحيوية.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وفي ١٤ سبتمبر ١١٤٦م أثناء معركة عند قلعة جعبر على ضفاف الفرات، تسلَّل في الليل ثلاثة مِن عبيده الخَدم إلى الخيمة وهو نائم بغية سرقة بعض الطعام والشراب، أفاق زنكي من الصوت، فسبَّهم ونهرَهم، ورجَع إلى النوم، خاف العبيد ممَّا سيحدث لهم في الغد، فاجتمعوا عليه وطعنوه بسيفه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كانت الضربة القاتلة بواسطة أحد عبيده (ياروكتاش)، وهرب العبيد الذين كانوا يعيشون ويأكلون مِن خيره.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("انشغل أبناؤه بتقسيم الميراث وإرضاء ولي العهد، وأُصيب الجيش بحالة مِن الشلل والبؤس، وتناثروا في حزن واستسلام، تركوا الرجل الذي أطعمهم وقادهم في كل هذه المعارك والانتصارات وحيدًا في خيمته")]), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn14",
      "id": "fnref14"
    }
  }, [_vm._v("14")]), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ولَم ينتبه للواجب إلا مجموعة مِن الغرباء الذين تعاملوا مع رفاته، فحملوه على سفينة إلى الرقَّة، ودفنوه بها، وبَعد مُضِيّ سنين رفع نور الدين محمود قبَّة فوق ضريحه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فرح الصليبيون لرحيل عماد الدين زنكي، لكنَّه ترك عملًا لَم يستطِع أيٌّ منهم القضاء عليه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وخلَف ابنه نور الدين محمود ومِن بَعده صلاح الدين، قائدان يعرفان كيف تتحقَّق أحلام زنكي التي بدأ في تنفيذها، فبعد أربعين عامًا على وفاته رجعَت أغلب الأراضي المقدَّسة بما فيها القدس للمسلمين بقيادة صلاح الدين.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("دعونا نَعُد مرة أخرى مع أيوب وعائلته، فبعد ترك تكريت واللجوء لزنكي في الموصل الذي أكرمهم كما سبق، خدم الأخَوَان (نجم الدين أيوب) و(أسد الدين شيركوه) لفترة في جيوش زنكي، وعندما سقطَت بعلبك عيّن أيوب حاكمًا للمدينة")]), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn15",
      "id": "fnref15"
    }
  }, [_vm._v("15")]), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v(". كانت شهرة بعلبك \"مدينة الشمس - هليوبوليس\" نابعة ليس فقط مِن الآثار والمعابد التاريخية، لكن لموقعها الجغرافي وارتفاعها عن سطح البحر بنحو ١٢٠٠ متر، فمنها ترى مَن أعلى معظم وادي الليطاني، وهي تبعد نحو خمسين كيلومتر فقط مِن دمشق، وهي مَن أبرد المدن مناخًا في سوريا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كانت بعلبك في وقت أيوب محوَّطة بحقول زراعية خصبة وأشجار فواكه، مياه عذبة تسري في المدينة، وطواحين هواء، يحميها سور قوي وقلعة غرب المدينة")]), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn16",
      "id": "fnref16"
    }
  }, [_vm._v("16")]), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لَم تكن قد عانت بعد مِن خراب المغول أو القوَّة الهدَّامة للزلازل التي حوَّلَتها لمدينة مهجورة، وكان تعيين أيوب حاكمًا على بعلبك دليلًا على ثقة زنكي به.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في هذا المكان والزمان قضى صلاح الدين جزءًا مِن طفولته التي لا نعلم عنها شيئًا، لكن بالأحرى أنَّه حصل على أعلى مستوى تعليمي عربي وإسلامي متاحٍ ببعلبك في ذلك الوقت، وذلك لا يقارَن بالتعليم الذي سيحصل عليه لاحقًا بدمشق.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كان عُمْر صلاح الدين تسع سنوات عندما اغتيل عماد الدين زنكي، وانتهز حاكم دمشق معين الدين أنر والد عصمت الدين خاتون هذه الفرصة لاسترجاع بعلبك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كان أيوب رجلًا دبلوماسيًّا محنَّكًا بعيد النظر، يرعى مصالحه ومصالح مدينته، كان يعلم أنَّ أولاد زنكي مشغولون بتوثيق الحكم والدفاع عن مقاطعة كلٍّ منهم، ولَم يُبْدِ أيوب أي مقاومة، فالموصل بعيدة، وحلب مصدومة وهادئة، ودمشق قريبة بالمقارنة وجادَّة في استرجاع بعلبك، ففضَّل التفاوض مِن القلعة وقَبِل بالاستسلام، وقد حصل بمقتضاه على تعويض في هيئة عشر قُرًى حول دمشق، وبيت في العاصمة، وسمح لجيوش دمشق بالدخول مِن الأبواب")]), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn17",
      "id": "fnref17"
    }
  }, [_vm._v("17")]), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("، وهذا دليل على ذكاء وحكمة مهَّدَا طريق أيوب لمركز عالٍ في دار القضاء، وبعد سنوات قليلة أصبح القائد الأعلى لجيوش دمشق، لكن شيركوه أخا أيوب فضَّل الخدمة في جيش نور الدين في حلب.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "footnotes"
  }, [_c('hr'), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "fn1"
    }
  }, [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("\"التاريخ الباهر في الدولة الأتابكية لابن الأثير عن تاريخ الدولة الزنكية\" (الدولة الأتابكية) ٢٩- ٣٠.")]), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref1"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "fn2"
    }
  }, [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عماد الدين زنكي: د. عماد الدين خليل - مؤسسة الرسالة - بيروت")]), _vm._v(" 1402"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هـ -")]), _vm._v(" 1982"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("م.")]), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref2"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "fn3"
    }
  }, [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ابن الأثير أتابج ص ٣٤- ٣٥ مرجع (٨).")]), _vm._v(" Stanley Lane-Poole, \"SALADIN and the Fall of JERUSALEM\". Greenhill Books, London 2016. "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }), _vm._v("P 51"), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref3"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "direction": "ltr"
    },
    attrs: {
      "id": "fn4"
    }
  }, [_c('p', [_vm._v("Stanley Lane-Poole, \"SALADIN and the fall of JERUSALEM\". Greenhill Books, London 2016. P 52"), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref4"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "direction": "ltr"
    },
    attrs: {
      "id": "fn5"
    }
  }, [_c('p', [_vm._v("Saladin and the Fall of the Kingdom of Jerusalem. By Lane-Poole Stanley, M. A. (New York and London: G. P. Putnam's Sons. 1898. Pp. xxiv, 54.)"), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref5"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "direction": "ltr"
    },
    attrs: {
      "id": "fn6"
    }
  }, [_c('p', [_vm._v("Saladin and the Fall of the Kingdom of Jerusalem. By Lane-Poole Stanley, M. A. (New York and London: G. P. Putnam's Sons. 1898. Pp. xxiv, 54.)"), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref6"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "direction": "ltr"
    },
    attrs: {
      "id": "fn7"
    }
  }, [_c('p', [_vm._v("Simon Sedbag Montefiore. \"JERUSALEM the biography\". Phoenix, Orion Books Ltd, London 2011. P 223-224"), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref7"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "direction": "ltr"
    },
    attrs: {
      "id": "fn8"
    }
  }, [_c('p', [_vm._v("Stanley Lane-Poole, \"SALADIN and the Fall of JERUSALEM\". Greenhill Books, London 2016. P 58"), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref8"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "direction": "ltr"
    },
    attrs: {
      "id": "fn9"
    }
  }, [_c('p', [_vm._v("Stanley Lane-Poole, \"SALADIN and the Fall of JERUSALEM\". Greenhill Books, London 2016. P 59"), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref9"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "direction": "ltr"
    },
    attrs: {
      "id": "fn10"
    }
  }, [_c('p', [_vm._v("https://www.sasapost.com/asad-ad-din-shirkuh/"), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref10"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "direction": "ltr"
    },
    attrs: {
      "id": "fn11"
    }
  }, [_c('p', [_vm._v("https://en.wikipedia.org/wiki/Battle_of_Ba%27rin"), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref11"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "direction": "ltr"
    },
    attrs: {
      "id": "fn12"
    }
  }, [_c('p', [_vm._v("Stanley Lane-Poole, \"SALADIN and the Fall of JERUSALEM\". Greenhill Books, London 2016. P "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("61")]), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref12"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "direction": "ltr"
    },
    attrs: {
      "id": "fn13"
    }
  }, [_c('p', [_vm._v("Stanley Lane-Poole, \"SALADIN and the Fall of JERUSALEM\". Greenhill Books, London 2016. P "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("63")]), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref13"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "direction": "ltr"
    },
    attrs: {
      "id": "fn14"
    }
  }, [_c('p', [_vm._v("Taef El-Azhari, Zengi and the Muslim Response to the Crusades, 1084-1146 P. 155 (Routlege, ISBN 9781138821019 February 2015)"), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref14"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "direction": "ltr"
    },
    attrs: {
      "id": "fn15"
    }
  }, [_c('p', [_vm._v("Ibn al-Athir, al-Bahir, tr. El-Azhari, Zengi P. 167"), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref15"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "direction": "ltr"
    },
    attrs: {
      "id": "fn16"
    }
  }, [_c('p', [_vm._v("https://www.medievalists.net/2012/03/al-idrisi-and-his-world-map-1154/"), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref16"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "direction": "ltr"
    },
    attrs: {
      "id": "fn17"
    }
  }, [_c('p', [_vm._v("Jonathan Phillips, \"The Life and Legend of the Sultan SALADIN\". The Bodley Head, London 2019. P. 19."), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref17"
    }
  }, [_vm._v("↩︎")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49f48c78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch009.vue
// module id = 87
// module chunks = 0